import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PortfolioContactsRestService } from './portfolio-contacts.rest.service';

export interface PortfolioContactData {
  accountNumber: string;
  portfolioManagerName: string;
  portfolioManagerPhone: string;
}

@Component({
  selector: 'td-wb-pic-contacts',
  templateUrl: './portfolio-contacts.component.html',
  styleUrls: ['./portfolio-contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PortfolioContactsComponent implements OnInit, OnDestroy {
  contactData: PortfolioContactData;
  private subscription: Subscription;

  constructor(private portfolioContactsRestService: PortfolioContactsRestService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.subscription = this.portfolioContactsRestService.getContactData().subscribe((data: PortfolioContactData): void => {
      this.contactData = data;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  showName(): boolean {
    return this.contactData?.portfolioManagerName !== undefined;
  }

  showPhone(): boolean {
    return this.contactData?.portfolioManagerPhone !== undefined;
  }
}
